import { TBookingProviderProps } from './booking'
import { useImmerReducer } from 'use-immer'

import { bookingReducer } from './booking_reducer'
import { BookingContext, initialState } from './booking_context'

export const BookingProvider = ({ children }: TBookingProviderProps) => {
  const [state, dispatch] = useImmerReducer(bookingReducer, initialState)
  const { Provider } = BookingContext

  return <Provider value={{ state, dispatch }}> {children} </Provider>
}
